<template>
  <div class="default-icon" :style="{color: color, borderColor: color}">
    <div class="default-icon__label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'Default',
  props: {
    color: {
      type: String,
      default: '#FFFFFF'
    },
    label: {
      type: String,
      default: 'Channel'
    }
  }
}
</script>

<style lang="scss" scoped>
.default-icon {
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  position: relative;
  min-height: 22px;
  min-width: 22px;
  border: 1px solid;
  padding: 2px;
  border-radius: 4px;

  &__label {
    font-size: 8px;
    font-weight: 500;
  }
}
</style>